import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { CartContext } from '../context/CartContext';
import { api } from '../services/api';
import './Menu.css';
import { resolveMediaUrl } from '../utils/media';

function Menu() {
  const [isOpen, setIsOpen] = useState(false);
  const [promoBanners, setPromoBanners] = useState([]);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isPromoDismissed, setIsPromoDismissed] = useState(false);
  const { isAuthenticated, logout, user } = useContext(AuthContext);
  const { cart } = useContext(CartContext);

  // Détection du scroll pour effet de menu compact
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const fetchPromoBanners = async () => {
      try {
        // Récupérer uniquement les bandes défilantes pour le menu
        const response = await api.get('/promo-banners/?type=banner');
        const data = await response.json();
        setPromoBanners(data);
      } catch (err) {
        console.error('Erreur lors du chargement des promotions:', err);
        setPromoBanners([]);
      }
    };

    fetchPromoBanners();
  }, []);


  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Calculer le nombre total d'articles dans le panier
  const getCartItemCount = () => {
    if (!cart) return 0;

    let total = 0;

    // Compter les événements individuels
    if (cart.items && cart.items.length > 0) {
      total += cart.items.reduce((sum, item) => {
        let itemCount = 0;
        if (item.quantity_adult !== undefined) {
          itemCount += parseInt(item.quantity_adult) || 0;
        }
        if (item.quantity_child !== undefined) {
          itemCount += parseInt(item.quantity_child) || 0;
        }
        if (item.quantity !== undefined) {
          itemCount += parseInt(item.quantity) || 0;
        }
        return sum + itemCount;
      }, 0);
    }

    // Compter les pass
    if (cart.pass_items && cart.pass_items.length > 0) {
      total += cart.pass_items.reduce((sum, item) => {
        let itemCount = 0;
        if (item.quantity_adult !== undefined) {
          itemCount += parseInt(item.quantity_adult) || 0;
        }
        if (item.quantity_child !== undefined) {
          itemCount += parseInt(item.quantity_child) || 0;
        }
        return sum + itemCount;
      }, 0);
    }

    return total;
  };

  return (
    <>
      <nav className={`menu ${isScrolled ? 'scrolled' : ''}`}>
        <div className="menu-brand shine">
          <Link to="/">
            <i className="fas fa-umbrella-beach"></i>
            Le Pass Réunion
          </Link>
        </div>

        <button className="menu-toggle" onClick={toggleMenu}>
          <span className={`hamburger ${isOpen ? 'active' : ''}`}></span>
        </button>

        <ul className={`menu-items ${isOpen ? 'active' : ''}`}>
          <li>
            <Link to="/" onClick={toggleMenu}>
              <i className="fas fa-home"></i>
              <span>Accueil</span>
            </Link>
          </li>
          <li>
            <Link to="/events" onClick={toggleMenu}>
              <i className="fas fa-calendar-alt"></i>
              <span>Événements</span>
            </Link>
          </li>
          <li>
            <Link to="/passes" onClick={toggleMenu} className="nav-cta">
              <i className="fas fa-ticket-alt"></i>
              <span>Pass</span>
            </Link>
          </li>
          <li>
            <Link to="/cart" onClick={toggleMenu} className="cart-link">
              <i className="fas fa-shopping-cart"></i>
              <span>Panier</span>
              <span className="cart-badge pulse">{getCartItemCount()}</span>
            </Link>
          </li>
          {isAuthenticated ? (
            <>
              {user?.is_organizer && (
                <li>
                  <Link to="/organizer/dashboard" onClick={toggleMenu}>
                    <i className="fas fa-chart-bar"></i>
                    <span>Mon espace</span>
                  </Link>
                </li>
              )}
              <li>
                <Link to="/profile" onClick={toggleMenu}>
                  <i className="fas fa-user"></i>
                  <span>Mon Profil</span>
                </Link>
              </li>
              <li>
                <button onClick={() => {
                  logout();
                  toggleMenu();
                }} className="menu-button">
                  <i className="fas fa-sign-out-alt"></i>
                  <span>Déconnexion</span>
                </button>
              </li>
            </>
          ) : (
            <li>
              <Link to="/login" onClick={toggleMenu} className="login-link nav-ghost">
                <i className="fas fa-sign-in-alt"></i>
                <span>Connexion</span>
              </Link>
            </li>
          )}
          <li>
            <Link to="/contact" onClick={toggleMenu}>
              <i className="fas fa-envelope"></i>
              <span>Contact</span>
            </Link>
          </li>
        </ul>

        <div className="menu-social">
          <a href="tet" className="social-icon" title="Facebook">
            <i className="fab fa-facebook-f"></i>
          </a>
          <a href="tet" className="social-icon" title="Instagram">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="tet" className="social-icon" title="Twitter">
            <i className="fab fa-twitter"></i>
          </a>
        </div>
      </nav>

      {promoBanners.length > 0 && !isPromoDismissed && (
        <div className="promo-ribbon">
          <div className="promo-ticker-track">
            {[0, 1].map((copy) => (
              <div className="promo-ticker-inner" aria-hidden={copy === 1 ? 'true' : undefined} key={copy}>
                {promoBanners.map((banner, i) => {
                  const handleClick = async () => {
                    if (banner.lien) {
                      try { await api.post(`/promo-banners/${banner.id}/click/`); } catch {}
                    }
                  };
                  const inner = (
                    <>
                      {banner.image ? (
                        <img src={resolveMediaUrl(banner.image)} alt="" className="promo-ribbon-img" loading="lazy" />
                      ) : banner.icone ? (
                        <i className={`fas ${banner.icone} promo-ribbon-icon`}></i>
                      ) : (
                        <span className="promo-ribbon-dot">✦</span>
                      )}
                      {banner.titre && <strong className="promo-ribbon-title">{banner.titre}</strong>}
                      <span className="promo-ribbon-text">{banner.texte}</span>
                    </>
                  );
                  return (
                    <React.Fragment key={banner.id}>
                      {i > 0 && <span className="promo-ribbon-sep">✦</span>}
                      {banner.lien ? (
                        <a href={banner.lien} className="promo-ribbon-item" onClick={handleClick} target="_blank" rel="noopener noreferrer">{inner}</a>
                      ) : (
                        <span className="promo-ribbon-item">{inner}</span>
                      )}
                    </React.Fragment>
                  );
                })}
                <span className="promo-ribbon-sep">✦</span>
              </div>
            ))}
          </div>
          <button className="promo-ribbon-close" onClick={() => setIsPromoDismissed(true)} aria-label="Fermer">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
      )}
    </>
  );
}

export default Menu; 